<template>
  <div class="container-two-column w-100">
    <bf-row :gutter="24" type="flex" align="middle" justify="center">
      <bf-col :span="20" :mobile="24" :class="{ 'w-100': !isEnableLeftPromotion }">
        <bf-row type="flex" justify="center" align="middle">
          <!-- begin::Left Layout Component -->
          <bf-col
            v-if="isEnableLeftPromotion"
            :span="12"
            :mobile="24"
            class="left-promotion-component"
            :class="isMobile ? 'order-1' : ''"
          >
            <div class="p-m">
              <!-- FIRST COLUMN -->
              <slot name="first-column"/>
              <!-- END FIRST COLUMN -->
            </div>
          </bf-col>
          <!-- end::Left Layout Component -->
          <!-- begin::Right Layout Component -->
          <bf-col :span="12" :mobile="24" :class="{ 'w-100': !isEnableLeftPromotion }">
            <!-- SECOND COLUMN -->
            <slot name="main" />
            <!-- END SECOND COLUMN -->
          </bf-col>
          <!-- end::Right Layout Component -->
        </bf-row>
      </bf-col>
    </bf-row>
    <!-- FOOTER ADS -->
    <slot name="footer" />
    <!-- END FOOTER ADS -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ContainerTwoColumn',
  props: {
    isEnableLeftPromotion: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('device', [
      'isMobile',
    ]),
  },
};
</script>
